import { organisationProfileDescriptor } from './spine-organisation-profile.js';
import { orgUnitDescriptor } from './spine-org-unit.js';
import { roleDescriptor } from './spine-role.js';
import { activityDescriptor } from './spine-activity.js';
import { locationDescriptor } from './spine-location.js';
import { dataCategoryDescriptor } from './spine-data-category.js';
import { dataSubjectCategoryDescriptor } from './spine-data-subject-category.js';
export const spineDescriptors = [
    organisationProfileDescriptor,
    orgUnitDescriptor,
    roleDescriptor,
    activityDescriptor,
    locationDescriptor,
    dataCategoryDescriptor,
    dataSubjectCategoryDescriptor,
];
